(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

    let scrollLockY = 0;

    function isMobile() {
      return MOBILE_MQ.matches;
    }

    function hasOpenPopup() {
      return document.querySelector('.product-card__popup.is-open') !== null;
    }

    function lockScroll() {
      scrollLockY = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = '-' + scrollLockY + 'px';
    }

    function unlockScroll() {
      document.body.style.top = '';
      document.body.classList.remove('fixed');
      window.scrollTo(0, scrollLockY);
    }

    function closeAllPopups(exceptPopup) {
      document.querySelectorAll('.product-card__popup.is-open').forEach((otherPopup) => {
        if (otherPopup === exceptPopup) return;

        const otherCard = otherPopup._originCard ?? otherPopup.closest('.product-card');
        otherPopup.classList.remove('is-open');
        otherPopup.hidden = true;
        otherPopup.setAttribute('aria-hidden', 'true');
        otherCard?.classList.remove('is-active');

        if (isMobile()) reattachPopup(otherPopup);
      });
    }

    function detachPopup(popup) {
      popup._originParent = popup.parentNode;
      popup._originNextSibling = popup.nextSibling;

      const placeholder = document.createComment('popup-placeholder');
      popup.parentNode.insertBefore(placeholder, popup.nextSibling);
      popup._placeholder = placeholder;

      document.body.appendChild(popup);
    }

    function reattachPopup(popup) {
      if (!popup._originParent) return;

      popup._originParent.insertBefore(popup, popup._originNextSibling);
      popup._placeholder?.remove();

      popup._originParent = null;
      popup._originNextSibling = null;
      popup._placeholder = null;
    }

    async function loadProductByHandle(handle) {
      const response = await fetch(`/products/${handle}.js`);
      return response.json();
    }

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;

      const openPopup = document.querySelector('.product-card__popup.is-open');

      if (!openPopup) return;

      const card = openPopup._originCard ?? openPopup.closest('.product-card');
      openPopup.classList.remove('is-open');
      openPopup.hidden = true;
      openPopup.setAttribute('aria-hidden', 'true');
      card?.classList.remove('is-active');

      if (isMobile()) reattachPopup(openPopup);

      if (isMobile() && !hasOpenPopup()) unlockScroll();
    });

    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach((card) => {
      const quickAddBtn = card.querySelector('.product-card__quick-add');
      const popup = card.querySelector('.product-card__popup');

      if (!popup) return;

      popup._originCard = card;

      const form = card.querySelector('form');
      const variantIdInput = card.querySelector('.js-variant-id');
      const optionInputs = card.querySelectorAll('.js-option');
      const addToCartBtn = card.querySelector('.product-card__add-to-cart');
      const addToCartBtnLabel = addToCartBtn?.querySelector('span');

      //const productData = JSON.parse(card.querySelector('script[type="application/json"]').textContent);
      const jsonScript = card.querySelector('script[type="application/json"]');

      if (!jsonScript) return;

      const productData = JSON.parse(jsonScript.textContent);

      const colorOptions = card.querySelectorAll('.product-card__color-option');
      const hasColorOptions = colorOptions.length > 0;
      const hasSizeOptions = optionInputs.length > 0;
      const activeColorOption = card.querySelector('.product-card__color-option.is-active');
      let selectedColor = activeColorOption?.dataset.colorValue || '';

      function getSelectedSize() {
        const checkedInput = Array.from(optionInputs).find((input) => input.checked);
        return checkedInput ? checkedInput.value : '';
      }

      function updateAddToCartState() {
        if (!addToCartBtn || !addToCartBtnLabel) return;

        const selectedSize = getSelectedSize();
        const colorSelected = !hasColorOptions || Boolean(selectedColor);
        const sizeSelected = !hasSizeOptions || Boolean(selectedSize);

        if (!colorSelected) {
          addToCartBtn.disabled = true;
          addToCartBtnLabel.textContent = 'Choose color';
          return;
        }

        if (!sizeSelected) {
          addToCartBtn.disabled = true;
          addToCartBtnLabel.textContent = 'Choose size';
          return;
        }

        addToCartBtn.classList.remove('btn--secondary');
        addToCartBtn.classList.add('btn--primary');
        addToCartBtn.disabled = false;
        addToCartBtnLabel.textContent = 'Add to cart';
      }

      function updateVariantId() {
        const selectedOptions = [];

        optionInputs.forEach((input) => {
          if (input.checked) {
            selectedOptions.push({
              value: input.value,
              position: Number(input.dataset.optionPosition),
            });
          }
        });

        const selectedVariant = productData.variants.find((variant) => {
          return selectedOptions.every((option) => {
            return variant.options[option.position] === option.value;
          });
        });

        if (selectedVariant) {
          variantIdInput.value = selectedVariant.id;
        }

        updateAddToCartState();
      }

      function openPopup() {
        const openBefore = hasOpenPopup();
        closeAllPopups(popup);

        if (isMobile()) detachPopup(popup);

        popup.classList.add('is-open');
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        card.classList.add('is-active');

        if (isMobile() && !openBefore) lockScroll();

        updateAddToCartState();
      }

      function closePopup() {
        if (!popup.classList.contains('is-open')) return;

        popup.classList.remove('is-open');
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        card.classList.remove('is-active');

        if (isMobile()) reattachPopup(popup);

        if (isMobile() && !hasOpenPopup()) unlockScroll();
      }

      optionInputs.forEach((input) => {
        input.addEventListener('change', updateVariantId);
      });

      colorOptions.forEach((colorOption) => {
        colorOption.addEventListener('click', async function () {
          colorOptions.forEach((c) => c.classList.remove('is-active'));
          this.classList.add('is-active');
          selectedColor = this.dataset.colorValue || '';

          // update primary card when color option is clicked
          const handle = this.dataset.productHandle;

          if (!handle) return;

          const newProduct = await loadProductByHandle(handle);

          productData.variants = newProduct.variants;
          form.dataset.productId = newProduct.id;

          updateCardImages(newProduct);
          updateSizeOptions(newProduct);
          updateAddToCartState();
        });
      });

      form?.addEventListener('submit', async function (event) {
        const selectedSize = getSelectedSize();
        const colorSelected = !hasColorOptions || Boolean(selectedColor);
        const sizeSelected = !hasSizeOptions || Boolean(selectedSize);

        if (!colorSelected || !sizeSelected) {
          event.preventDefault();
          updateAddToCartState();
          return;
        }

        if (theme.settings.afterAddToCart !== 'drawer') return;

        event.preventDefault();

        if (addToCartBtn.getAttribute('aria-disabled') === 'true') return;

        // Disable "Add to Cart" button until submission is complete.
        addToCartBtn.setAttribute('aria-disabled', 'true');
        addToCartBtn.classList.add('is-loading');

        const formData = new FormData(form);

        const sectionsToUpdate = ['page-header', 'cart-drawer']
          .map((sel) => document.querySelector(sel))
          .filter(Boolean);
        const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };

        try {
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          const data = await response.json();

          if (!response.ok) throw new Error(response.status);

          if (data.sections) {
            sectionsToUpdate.forEach((el) => {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            });
          }

          document.querySelector('.js-cart-drawer').open();

          this.dispatchEvent(
            new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                variantId: data.variant_id,
              },
            })
          );

          addToCartBtn.classList.add('is-success');
        } catch (error) {
          console.error('Error adding to cart:', error);

          this.dispatchEvent(
            new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: {
                error: form.querySelector('.js-error-msg')?.textContent ?? '',
              },
            })
          );
        } finally {
          // Re-enable 'Add to Cart' button.
          addToCartBtn.removeAttribute('aria-disabled');

          setTimeout(() => {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.classList.remove('is-success');
          }, 2000);

          closePopup();
        }
      });

      quickAddBtn?.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        openPopup();
      });

      popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closePopup();
        });
      });

      updateAddToCartState();

      function updateSizeOptions(newProduct) {
        const sizeOptionIndex = newProduct.options.findIndex((opt) => opt.name.toLowerCase().includes('size'));

        if (sizeOptionIndex === -1) return;

        const sizeContainer = form.querySelector('.product-card__option-values[data-option]');

        if (!sizeContainer) return;

        // Собираем доступность каждого значения
        const valuesMap = {};
        newProduct.variants.forEach((variant) => {
          const value = variant.options[sizeOptionIndex];

          if (!valuesMap[value]) valuesMap[value] = false;

          if (variant.available) valuesMap[value] = true;
        });

        // Обновляем существующие label-ы — не перерисовываем DOM полностью
        sizeContainer.querySelectorAll('label').forEach((label) => {
          const input = label.querySelector('input');
          if (!input) return;

          const value = input.value;
          const available = valuesMap[value] ?? false;

          input.disabled = !available;
          input.checked = false;

          label.classList.toggle('product-card-option-active', available);
          label.classList.toggle('product-card-option-disabled', !available);
        });

        // Сбрасываем variant id до первого доступного варианта нового продукта
        const firstAvailable = newProduct.variants.find((v) => v.available);
        variantIdInput.value = firstAvailable?.id ?? newProduct.variants[0].id;
      }

      function updateCardImages(newProduct) {
        const [primaryUrl, secondaryUrl] = newProduct.images;
        const primaryImg = card.querySelector('.product-card__image');
        const secondaryImg = card.querySelector('.product-card__image-secondary');
        const popupImg = document.querySelector('.product-card__popup.is-open .product-card__popup-image');
        const cardLink = card.querySelector('.product-card__link');

        const sized = (url, w) => url.replace(/(\.[^.]+)$/, `_${w}x$1`);

        function setImgSrc(img, url) {
          img.src = 'https:' + sized(url, 600);
          img.srcset = [`https:${sized(url, 600)} 600w`, `https:${sized(url, 1200)} 1200w`].join(', ');
        }

        // 1. Fade out
        primaryImg?.classList.add('is-loading-image');

        // 2. Меняем src
        if (primaryImg && primaryUrl) {
          setImgSrc(primaryImg, primaryUrl);
        }

        if (secondaryImg) {
          const url = secondaryUrl ?? primaryUrl;
          if (url) setImgSrc(secondaryImg, url);
        }

        // 3. Fade in когда браузер загрузил новую картинку
        if (primaryImg && primaryUrl) {
          primaryImg.onload = () => primaryImg.classList.remove('is-loading-image');
          primaryImg.onerror = () => primaryImg.classList.remove('is-loading-image');
        }

        // 4. Обновляем картинку в попапе, если он открыт
        if (popupImg && primaryUrl) {
          setImgSrc(popupImg, primaryUrl);
        }

        // 5. Обновляем ссылку на карточке, если она ведет на другой продукт
        if (cardLink && cardLink.getAttribute('href') !== newProduct.url) {
          cardLink.setAttribute('href', newProduct.url);
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-primary-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

    let scrollLockY = 0;

    function isMobile() {
      return MOBILE_MQ.matches;
    }

    function hasOpenPopup() {
      return document.querySelector('.product-card__popup.is-open') !== null;
    }

    function lockScroll() {
      scrollLockY = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = '-' + scrollLockY + 'px';
    }

    function unlockScroll() {
      document.body.style.top = '';
      document.body.classList.remove('fixed');
      window.scrollTo(0, scrollLockY);
    }

    function closeAllPopups(exceptPopup) {
      document.querySelectorAll('.product-card__popup.is-open').forEach((otherPopup) => {
        if (otherPopup === exceptPopup) return;

        const otherCard = otherPopup._originCard ?? otherPopup.closest('.product-card');
        otherPopup.classList.remove('is-open');
        otherPopup.hidden = true;
        otherPopup.setAttribute('aria-hidden', 'true');
        otherCard?.classList.remove('is-active');

        if (isMobile()) reattachPopup(otherPopup);
      });
    }

    function detachPopup(popup) {
      popup._originParent = popup.parentNode;
      popup._originNextSibling = popup.nextSibling;

      const placeholder = document.createComment('popup-placeholder');
      popup.parentNode.insertBefore(placeholder, popup.nextSibling);
      popup._placeholder = placeholder;

      document.body.appendChild(popup);
    }

    function reattachPopup(popup) {
      if (!popup._originParent) return;

      popup._originParent.insertBefore(popup, popup._originNextSibling);
      popup._placeholder?.remove();

      popup._originParent = null;
      popup._originNextSibling = null;
      popup._placeholder = null;
    }

    async function loadProductByHandle(handle) {
      const response = await fetch(`/products/${handle}.js`);
      return response.json();
    }

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;

      const openPopup = document.querySelector('.product-card__popup.is-open');

      if (!openPopup) return;

      const card = openPopup._originCard ?? openPopup.closest('.product-card');
      openPopup.classList.remove('is-open');
      openPopup.hidden = true;
      openPopup.setAttribute('aria-hidden', 'true');
      card?.classList.remove('is-active');

      if (isMobile()) reattachPopup(openPopup);

      if (isMobile() && !hasOpenPopup()) unlockScroll();
    });

    const productCards = document.querySelectorAll('.product-card');

    productCards.forEach((card) => {
      const quickAddBtn = card.querySelector('.product-card__quick-add');
      const popup = card.querySelector('.product-card__popup');

      if (!popup) return;

      popup._originCard = card;

      const form = card.querySelector('form');
      const variantIdInput = card.querySelector('.js-variant-id');
      const optionInputs = card.querySelectorAll('.js-option');
      const addToCartBtn = card.querySelector('.product-card__add-to-cart');
      const addToCartBtnLabel = addToCartBtn?.querySelector('span');

      //const productData = JSON.parse(card.querySelector('script[type="application/json"]').textContent);
      const jsonScript = card.querySelector('script[type="application/json"]');

      if (!jsonScript) return;

      const productData = JSON.parse(jsonScript.textContent);

      const colorOptions = card.querySelectorAll('.product-card__color-option');
      const hasColorOptions = colorOptions.length > 0;
      const hasSizeOptions = optionInputs.length > 0;
      const activeColorOption = card.querySelector('.product-card__color-option.is-active');
      let selectedColor = activeColorOption?.dataset.colorValue || '';

      function getSelectedSize() {
        const checkedInput = Array.from(optionInputs).find((input) => input.checked);
        return checkedInput ? checkedInput.value : '';
      }

      function updateAddToCartState() {
        if (!addToCartBtn || !addToCartBtnLabel) return;

        const selectedSize = getSelectedSize();
        const colorSelected = !hasColorOptions || Boolean(selectedColor);
        const sizeSelected = !hasSizeOptions || Boolean(selectedSize);

        if (!colorSelected) {
          addToCartBtn.disabled = true;
          addToCartBtnLabel.textContent = 'Choose color';
          return;
        }

        if (!sizeSelected) {
          addToCartBtn.disabled = true;
          addToCartBtnLabel.textContent = 'Choose size';
          return;
        }

        addToCartBtn.classList.remove('btn--secondary');
        addToCartBtn.classList.add('btn--primary');
        addToCartBtn.disabled = false;
        addToCartBtnLabel.textContent = 'Add to cart';
      }

      function updateVariantId() {
        const selectedOptions = [];

        optionInputs.forEach((input) => {
          if (input.checked) {
            selectedOptions.push({
              value: input.value,
              position: Number(input.dataset.optionPosition),
            });
          }
        });

        const selectedVariant = productData.variants.find((variant) => {
          return selectedOptions.every((option) => {
            return variant.options[option.position] === option.value;
          });
        });

        if (selectedVariant) {
          variantIdInput.value = selectedVariant.id;
        }

        updateAddToCartState();
      }

      function openPopup() {
        const openBefore = hasOpenPopup();
        closeAllPopups(popup);

        if (isMobile()) detachPopup(popup);

        popup.classList.add('is-open');
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        card.classList.add('is-active');

        if (isMobile() && !openBefore) lockScroll();

        updateAddToCartState();
      }

      function closePopup() {
        if (!popup.classList.contains('is-open')) return;

        popup.classList.remove('is-open');
        popup.hidden = true;
        popup.setAttribute('aria-hidden', 'true');
        card.classList.remove('is-active');

        if (isMobile()) reattachPopup(popup);

        if (isMobile() && !hasOpenPopup()) unlockScroll();
      }

      optionInputs.forEach((input) => {
        input.addEventListener('change', updateVariantId);
      });

      colorOptions.forEach((colorOption) => {
        colorOption.addEventListener('click', async function () {
          colorOptions.forEach((c) => c.classList.remove('is-active'));
          this.classList.add('is-active');
          selectedColor = this.dataset.colorValue || '';

          // update primary card when color option is clicked
          const handle = this.dataset.productHandle;

          if (!handle) return;

          const newProduct = await loadProductByHandle(handle);

          productData.variants = newProduct.variants;
          form.dataset.productId = newProduct.id;

          updateCardImages(newProduct);
          updateSizeOptions(newProduct);
          updateAddToCartState();
        });
      });

      form?.addEventListener('submit', async function (event) {
        const selectedSize = getSelectedSize();
        const colorSelected = !hasColorOptions || Boolean(selectedColor);
        const sizeSelected = !hasSizeOptions || Boolean(selectedSize);

        if (!colorSelected || !sizeSelected) {
          event.preventDefault();
          updateAddToCartState();
          return;
        }

        if (theme.settings.afterAddToCart !== 'drawer') return;

        event.preventDefault();

        if (addToCartBtn.getAttribute('aria-disabled') === 'true') return;

        // Disable "Add to Cart" button until submission is complete.
        addToCartBtn.setAttribute('aria-disabled', 'true');
        addToCartBtn.classList.add('is-loading');

        const formData = new FormData(form);

        const sectionsToUpdate = ['page-header', 'cart-drawer']
          .map((sel) => document.querySelector(sel))
          .filter(Boolean);
        const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId);

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };

        try {
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          const data = await response.json();

          if (!response.ok) throw new Error(response.status);

          if (data.sections) {
            sectionsToUpdate.forEach((el) => {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            });
          }

          document.querySelector('.js-cart-drawer').open();

          this.dispatchEvent(
            new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                variantId: data.variant_id,
              },
            })
          );

          addToCartBtn.classList.add('is-success');
        } catch (error) {
          console.error('Error adding to cart:', error);

          this.dispatchEvent(
            new CustomEvent('on:cart:error', {
              bubbles: true,
              detail: {
                error: form.querySelector('.js-error-msg')?.textContent ?? '',
              },
            })
          );
        } finally {
          // Re-enable 'Add to Cart' button.
          addToCartBtn.removeAttribute('aria-disabled');

          setTimeout(() => {
            addToCartBtn.classList.remove('is-loading');
            addToCartBtn.classList.remove('is-success');
          }, 2000);

          closePopup();
        }
      });

      quickAddBtn?.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        openPopup();
      });

      popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          closePopup();
        });
      });

      updateAddToCartState();

      function updateSizeOptions(newProduct) {
        const sizeOptionIndex = newProduct.options.findIndex((opt) => opt.name.toLowerCase().includes('size'));

        if (sizeOptionIndex === -1) return;

        const sizeContainer = form.querySelector('.product-card__option-values[data-option]');

        if (!sizeContainer) return;

        // Собираем доступность каждого значения
        const valuesMap = {};
        newProduct.variants.forEach((variant) => {
          const value = variant.options[sizeOptionIndex];

          if (!valuesMap[value]) valuesMap[value] = false;

          if (variant.available) valuesMap[value] = true;
        });

        // Обновляем существующие label-ы — не перерисовываем DOM полностью
        sizeContainer.querySelectorAll('label').forEach((label) => {
          const input = label.querySelector('input');
          if (!input) return;

          const value = input.value;
          const available = valuesMap[value] ?? false;

          input.disabled = !available;
          input.checked = false;

          label.classList.toggle('product-card-option-active', available);
          label.classList.toggle('product-card-option-disabled', !available);
        });

        // Сбрасываем variant id до первого доступного варианта нового продукта
        const firstAvailable = newProduct.variants.find((v) => v.available);
        variantIdInput.value = firstAvailable?.id ?? newProduct.variants[0].id;
      }

      function updateCardImages(newProduct) {
        const [primaryUrl, secondaryUrl] = newProduct.images;
        const primaryImg = card.querySelector('.product-card__image');
        const secondaryImg = card.querySelector('.product-card__image-secondary');
        const popupImg = document.querySelector('.product-card__popup.is-open .product-card__popup-image');
        const cardLink = card.querySelector('.product-card__link');

        const sized = (url, w) => url.replace(/(\.[^.]+)$/, `_${w}x$1`);

        function setImgSrc(img, url) {
          img.src = 'https:' + sized(url, 600);
          img.srcset = [`https:${sized(url, 600)} 600w`, `https:${sized(url, 1200)} 1200w`].join(', ');
        }

        // 1. Fade out
        primaryImg?.classList.add('is-loading-image');

        // 2. Меняем src
        if (primaryImg && primaryUrl) {
          setImgSrc(primaryImg, primaryUrl);
        }

        if (secondaryImg) {
          const url = secondaryUrl ?? primaryUrl;
          if (url) setImgSrc(secondaryImg, url);
        }

        // 3. Fade in когда браузер загрузил новую картинку
        if (primaryImg && primaryUrl) {
          primaryImg.onload = () => primaryImg.classList.remove('is-loading-image');
          primaryImg.onerror = () => primaryImg.classList.remove('is-loading-image');
        }

        // 4. Обновляем картинку в попапе, если он открыт
        if (popupImg && primaryUrl) {
          setImgSrc(popupImg, primaryUrl);
        }

        // 5. Обновляем ссылку на карточке, если она ведет на другой продукт
        if (cardLink && cardLink.getAttribute('href') !== newProduct.url) {
          cardLink.setAttribute('href', newProduct.url);
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
